/** Корінь адмін-API диска (`DISK-006` §6.2). */
export const DISK_ADMIN_API = '/services/disk/admin'

/** Сегмент шляху з uuid — завжди екранований. */
export const adminPath = (...parts: string[]): string =>
    [DISK_ADMIN_API, ...parts.map((part) => encodeURIComponent(part))].join('/')
